import { taskToolInstance } from '@/shared/api/api-instances/task-tool/api-instance';
import type {
  PageSettingsSchema,
  SettingResponse,
  SettingsRequest,
} from '../model/types';
import type { AxiosRequestConfig } from 'axios';

export class TaskToolSettingsApi {
  static getAllSettings(params = {}, options: AxiosRequestConfig = {}) {
    return taskToolInstance.get<PageSettingsSchema>(`/settings`, {
      ...options,
      params,
    });
  }

  static getSettingById(setting_id: string, options: AxiosRequestConfig = {}) {
    return taskToolInstance.get<SettingResponse>(
      `/settings/${setting_id}`,
      options,
    );
  }

  static editSetting(
    setting_id: string,
    payload: SettingsRequest,
    options: AxiosRequestConfig = {},
  ) {
    return taskToolInstance.put<SettingResponse>(
      `/settings/${setting_id}`,
      payload,
      options,
    );
  }
}